 

import React, { useState, useEffect } from "react";
import api from "../../api/api";
import Select from "react-select";
import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";

const getTodayDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatDate = (dateString) => {
    if (!dateString) return getTodayDate();

    return dateString.split('T')[0];
};

const ServiceCost = ({ User, ServiceId, TicketId }) => {
  const [costList, setCostList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
  
  const [formData, setFormData] = useState({
    Date: getTodayDate(),
    ServiceType: "",
    Charges: "",
    Amount: "",
  });

  useEffect(() => {
    const fetchServiceTypes = async () => {
      try {
        const response = await api.GetAllTicketService(User, TicketId);
        const data =
          response?.data?.GetAllTicketServiceAPIjs?.Table7 ||
          response?.data?.Table7 ||
          response?.Table7 ||
          [];

        const formatted = data.map((item) => ({
          label: item.ServiceType,
          value: item.ServiceType,
        }));

        setServiceTypeOptions(formatted);
      } catch (error) {
        console.error("Error fetching service types:", error);
      }
    };

    if (User && TicketId) fetchServiceTypes();
  }, [User, TicketId]);


  // 1. Extracted data loading logic into a reusable function
  const loadCostData = async () => {
    if (!ServiceId || ServiceId === "0") return;
    
    try {
      const response = await api.EditServicesparelistAPI(ServiceId); 
      console.log("EditServicesparelistAPI response:", response);

      const data = 
          response?.data?.EditServicesparelistAPIjs?.Table2 || 
          response?.EditServicesparelistAPIjs?.Table2 ||
          response?.Table2 || 
          [];
          
      setCostList(data.map(item => ({
           ...item,
           // Ensure OthersId is used as the key
           OthersId: item.OthersId, 
           Id: item.OthersId, 
           ServiceType: item.Servicetype 
      })));

    } catch (error) {
      console.error("Failed to load existing service costs:", error);
    }
  };

  // 2. Initial data load useEffect calls the reusable function
  useEffect(() => {
    loadCostData();
  }, [ServiceId]); 

  const handleNew = () => {
    setFormData({
      Date: getTodayDate(),
      ServiceType: "",
      Charges: "",
      Amount: "",
    });
    setShowModal(true);
  };

  const handleDelete = async (itemToDelete) => {
    if (!window.confirm(`Are you sure you want to delete the service cost?`)) {
        return;
    }

    try {
        
        const response = await api.DeleteServiceCostAPI(itemToDelete.ServiceId, itemToDelete.OthersId); 
        console.log("DeleteServiceCostAPI response:", response);
        
        if (response) {
           // alert("Service Cost deleted successfully!");

            setCostList((prev) => prev.filter((item) => item.OthersId !== itemToDelete.OthersId));
        } else {
             alert("Failed to delete service cost. (API returned no success indicator)");
        }
    } catch (error) {
        console.error("Error deleting service cost:", error);
        alert("An error occurred while deleting service cost.");
    }
  };

  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleServiceTypeChange = (selected) => {
    setFormData((prev) => ({ ...prev, ServiceType: selected?.value || "" }));
  };

  const handleSave = async () => {
    if (!formData.ServiceType || !formData.Charges || !formData.Amount) {
      alert("Please fill all fields.");
      return;
    }
 const datePart = formData.Date; 
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
    const timePart = `${hours}:${minutes}:${seconds}.${milliseconds}`;
    const fullServiceDate = `${datePart} ${timePart}`;
    const payload = {
      ServiceId: ServiceId || "0", 
      Date: fullServiceDate,
      Charges: formData.Charges,
      Amount: formData.Amount,
      Servicetype: formData.ServiceType,
      Number: "0", 
    };
    
    try {
      const response = await api.SaveServiceCostAPI(payload);
      console.log("SaveServiceCostAPI response:", response);

      if (response) {
        alert("Service Cost saved successfully!");
  
        // 3. Removed the temporary item creation using Date.now()
        // 4. Reload the data from the API to get the correct OthersId
        await loadCostData();

        // Cleanup
        setShowModal(false); 
      } else {
        alert("Failed to save service cost. (API returned no response object)");
      }
    } catch (error) {
      console.error("Error saving service cost:", error);
      alert("An error occurred while saving service cost.");
    }
  };

  return (
    <div className="service-cost-container">
      <div className="header-row">
  <button className="btn-primary" onClick={handleNew}>
    + Add
  </button>
    <ExcelExport data={costList} fileName="ServiceCost" />
  <h3>Service Cost</h3>
</div>
      {costList.length > 0 ? (
        <table className="service-cost-table">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Date</th>
              <th>Service Type</th>
              <th>Charges</th>
              <th>Amount</th>
              <th>Action</th> {/* Added Action column */}
            </tr>
          </thead>
          <tbody>
            {costList.map((item, index) => (
              <tr 
                key={item.OthersId || index}
              >
                <td>{index + 1}</td>
                <td>{formatDate(item.Date)}</td>
                <td>{item.Servicetype}</td>
                <td>{item.Charges}</td>
                <td>{item.Amount}</td>
                <td>
                  <button 
                    className="btn-delete" 
                    onClick={() => handleDelete(item)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="placeholder-tab">No service cost records yet.</div>
      )}

      {/* Modal - Simplified for Insert Only */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Add Service Cost</h3>

            <div className="form-group-column">
              <label>Date</label>
              <input
                type="date"
                name="Date"
                value={formData.Date}
                onChange={handleChange}
              />

              <label>Service Type</label>
              <Select
                options={serviceTypeOptions}
                value={
                  serviceTypeOptions.find(
                    (opt) => opt.value === formData.ServiceType
                  ) || null
                }
                onChange={handleServiceTypeChange}
                placeholder="Select Service Type"
              />

              <label>Charges</label>
              <input
                type="number"
                name="Charges"
                value={formData.Charges}
                onChange={handleChange}
              />

              <label>Amount</label>
              <input
                type="number"
                name="Amount"
                value={formData.Amount}
                onChange={handleChange}
              />
            </div>

            <div className="form-actions">
              <button className="btn-primary" onClick={handleSave}>
                Save
              </button>
              <button
                className="btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Styles */}
      <style jsx>{`
        .service-cost-container {
          margin-top: 20px;
        }
        .btn-primary {
          background: #007bff;
          color: #fff;
          padding: 6px 14px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
        }
        .btn-secondary {
          background: #aaa;
          color: #fff;
          padding: 6px 14px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          margin-left: 8px;
        }
        .btn-delete {
          background: #dc3545; /* Red color for delete */
          color: #fff;
          padding: 4px 8px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 0.85em;
        }
        .service-cost-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 15px;
        }
        .service-cost-table th,
        .service-cost-table td {
          border: 1px solid #ccc;
          padding: 8px;
          text-align: left;
        }
        .placeholder-tab {
          margin-top: 10px;
          color: #777;
        }
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999;
        }
        .modal-content {
          background: #fff;
          border-radius: 12px;
          padding: 20px;
          width: 400px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        }
        .form-group-column {
          display: flex;
          flex-direction: column;
        }
        .form-group-column label {
          font-weight: 600;
          margin-top: 10px;
        }
        .form-group-column input {
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 6px;
          margin-top: 4px;
        }

          .header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.header-row h3 {
  margin: 0;
}

.btn-primary {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}
.btn-primary:hover {
  background-color: #0056b3;
}
      `}</style>
    </div>
  );
};

export default ServiceCost;